"use strict";
/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var XML_GramaticaAsc = (function () {
    var o = function (k, v, o, l) { for (o = o || {}, l = k.length; l--; o[k[l]] = v)
        ; return o; }, $V0 = [1, 10], $V1 = [1, 9], $V2 = [2, 5, 6], $V3 = [1, 13], $V4 = [1, 14], $V5 = [1, 19], $V6 = [2, 12], $V7 = [1, 18], $V8 = [2, 7, 10, 13, 14], $V9 = [1, 38], $Va = [1, 34], $Vb = [1, 35], $Vc = [1, 36], $Vd = [1, 37], $Ve = [1, 39], $Vf = [1, 40], $Vg = [1, 41], $Vh = [1, 42], $Vi = [1, 43], $Vj = [1, 44], $Vk = [2, 6, 8, 13, 22, 23, 24, 25, 26, 27, 28, 29, 30], $Vl = [2, 31];
    var parser = { trace: function trace() { },
        yy: {},
        symbols_: { "error": 2, "START": 3, "ENCABEZADO": 4, "EOF": 5, "lt": 6, "interrog": 7, "xml": 8, "LISTAATRIBUTOS": 9, "gt": 10, "LISTAELEMENTOS": 11, "ELEMENTO": 12, "identifier": 13, "diag": 14, "TEXTCONTENT": 15, "ATRIBUTOS": 16, "ATRIBUTO": 17, "asig": 18, "cadena": 19, "cadena2": 20, "TEXT": 21, "content": 22, "DoubleLiteral": 23, "IntegerLiteral": 24, "apos": 25, "less": 26, "greater": 27, "ampersand": 28, "apostrophe": 29, "quot": 30, "$accept": 0, "$end": 1 },
        terminals_: { 2: "error", 5: "EOF", 6: "lt", 7: "interrog", 8: "xml", 10: "gt", 13: "identifier", 14: "diag", 18: "asig", 19: "cadena", 20: "cadena2", 22: "content", 23: "DoubleLiteral", 24: "IntegerLiteral", 25: "apos", 26: "less", 27: "greater", 28: "ampersand", 29: "apostrophe", 30: "quot" },
        productions_: [0, [3, 2], [4, 7], [4, 2], [11, 2], [11, 1], [12, 5], [12, 9], [12, 9], [12, 8], [12, 2], [9, 1], [9, 0], [16, 2], [16, 1], [17, 3], [17, 3], [17, 1], [15, 2], [15, 1], [21, 1], [21, 1], [21, 1], [21, 1], [21, 1], [21, 1], [21, 1], [21, 1], [21, 1], [21, 1], [21, 1], [21, 1]],
        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
            /* this == yyval */
            var $0 = $$.length - 1;
            switch (yystate) {
                case 1:
                    /* CONSTRUCCION DE CST */
                    let raiz = new Nodo(cst.cstXmlAsc.getId(), 'START', null, [cst.cstXmlAsc.obtenerUltimoNodo()]);
                    cst.cstXmlAsc.setRaiz(raiz);
                    return $$[$0 - 1];
                    break;
                case 2:
                    $$[$0].unshift(new Objeto($$[$0 - 4], '', _$[$0 - 6].first_line, _$[$0 - 6].first_column, $$[$0 - 3], [], true));
                    this.$ = $$[$0];
                    /* CONSTRUCCION DE CST */
                    let elementos = cst.cstXmlAsc.obtenerUltimoNodo();
                    let atributosE = cst.cstXmlAsc.obtenerUltimoNodo();
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'ENCABEZADO', null, [new Nodo(cst.cstXmlAsc.getId(), 'lt', null, [new Nodo(cst.cstXmlAsc.getId(), '<', null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'interrog', null, [new Nodo(cst.cstXmlAsc.getId(), '?', null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'xml', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 4].toString().replaceAll("\"", ""), null, [])]),
                        atributosE,
                        new Nodo(cst.cstXmlAsc.getId(), 'interrog', null, [new Nodo(cst.cstXmlAsc.getId(), '?', null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'gt', null, [new Nodo(cst.cstXmlAsc.getId(), '>', null, [])]),
                        elementos]));
                    break;
                case 3:
                    errores.default.agregarError('sintáctico', 'Token inesperado \'' + yytext + '\'', _$[$0 - 1].first_line, _$[$0 - 1].first_column);
                    this.$ = $$[$0];
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'ENCABEZADO', null, [cst.cstXmlAsc.obtenerUltimoNodo()]));
                    break;
                case 4:
                    if ($$[$0 - 1] !== null) {
                        if ($$[$0] !== null)
                            $$[$0 - 1].push($$[$0]);
                        this.$ = $$[$0 - 1];
                    }
                    else if ($$[$0] !== null)
                        this.$ = [$$[$0 - 1]];
                    else
                        this.$ = [];
                    /* CONSTRUCCION DE CST */
                    let elem = cst.cstXmlAsc.obtenerUltimoNodo();
                    let listaElem = cst.cstXmlAsc.obtenerUltimoNodo();
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'LISTAELEMENTOS', null, [listaElem, elem]));
                    break;
                case 5:
                    if ($$[$0] !== null)
                        this.$ = [$$[$0]];
                    else
                        this.$ = [];
                    /* CONSTRUCCION DE CST */
                    let padreLE = new Nodo(cst.cstXmlAsc.getId(), 'LISTAELEMENTOS', null, [cst.cstXmlAsc.obtenerUltimoNodo()]);
                    cst.cstXmlAsc.agregarPila(padreLE);
                    break;
                case 6:
                    this.$ = new Objeto($$[$0 - 3], '', _$[$0 - 4].first_line, _$[$0 - 4].first_column, $$[$0 - 2], [], true);
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'ELEMENTO', null, [new Nodo(cst.cstXmlAsc.getId(), 'lt', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 4].toString().replaceAll("\"", ""), null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'identificador', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 3].toString().replaceAll("\"", ""), null, [])]),
                        cst.cstXmlAsc.obtenerUltimoNodo(),
                        new Nodo(cst.cstXmlAsc.getId(), 'diag', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 1].toString().replaceAll("\"", ""), null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'gt', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 7:
                    console.log(Objeto);
                    if ($$[$0 - 7] === $$[$0 - 1]) {
                        this.$ = new Objeto($$[$0 - 7], $$[$0 - 4].toString().replaceAll("\"", ""), _$[$0 - 8].first_line, _$[$0 - 8].first_column, $$[$0 - 6], [], false);
                    }
                    else {
                        console.log(errores.default);
                        console.log('Linea 111: Error semantico: Las etiquetas deben ser iguales:\n' + $$[$0 - 7] + "!=" + $$[$0 - 1] + " \natributos: " + $$[$0 - 6] + "\ntexto: \n" + $$[$0 - 4]);
                        errores.default.agregarError('semantico', 'Las etiquetas deben ser iguales', _$[$0 - 8].first_line, _$[$0 - 8].first_column);
                        this.$ = null;
                    }
                    /* CONSTRUCCION DE CST */
                    var elemText = cst.cstXmlAsc.obtenerUltimoNodo();
                    var elemAtr = cst.cstXmlAsc.obtenerUltimoNodo();
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'ELEMENTO', null, [new Nodo(cst.cstXmlAsc.getId(), 'lt', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 8].toString().replaceAll("\"", ""), null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'identificador', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 7].toString().replaceAll("\"", ""), null, [])]),
                        elemAtr,
                        new Nodo(cst.cstXmlAsc.getId(), 'gt', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 5].toString().replaceAll("\"", ""), null, [])]),
                        elemText,
                        new Nodo(cst.cstXmlAsc.getId(), 'lt', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 3].toString().replaceAll("\"", ""), null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'diag', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 2].toString().replaceAll("\"", ""), null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'identificador', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 1].toString().replaceAll("\"", ""), null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'gt', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 8:
                    if ($$[$0 - 7] === $$[$0 - 1]) {
                        this.$ = new Objeto($$[$0 - 7], '', _$[$0 - 8].first_line, _$[$0 - 8].first_column, $$[$0 - 6], $$[$0 - 4], false);
                    }
                    else {
                        console.log(errores.default);
                        console.log('Linea 120: Error semantico: Las etiquetas deben ser iguales');
                        errores.default.agregarError('semantico', 'Las etiquetas deben ser iguales', _$[$0 - 8].first_line, _$[$0 - 8].first_column);
                        this.$ = null;
                    }
                    /* CONSTRUCCION DE CST */
                    let elem1 = cst.cstXmlAsc.obtenerUltimoNodo();
                    let atr1 = cst.cstXmlAsc.obtenerUltimoNodo();
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'ELEMENTO', null, [new Nodo(cst.cstXmlAsc.getId(), 'lt', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 8].toString().replaceAll("\"", ""), null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'identificador', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 7].toString().replaceAll("\"", ""), null, [])]),
                        atr1,
                        new Nodo(cst.cstXmlAsc.getId(), 'gt', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 5].toString().replaceAll("\"", ""), null, [])]),
                        elem1,
                        new Nodo(cst.cstXmlAsc.getId(), 'lt', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 3].toString().replaceAll("\"", ""), null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'diag', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 2].toString().replaceAll("\"", ""), null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'identificador', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 1].toString().replaceAll("\"", ""), null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'gt', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 9:
                    if ($$[$0 - 6] === $$[$0 - 1]) {
                        this.$ = new Objeto($$[$0 - 6], '', _$[$0 - 7].first_line, _$[$0 - 7].first_column, $$[$0 - 5], [], false);
                    }
                    else {
                        console.log(errores.default);
                        console.log('Linea 129: Error semantico: Las etiquetas deben ser iguales');
                        errores.default.agregarError('semantico', 'Las etiquetas deben ser iguales', _$[$0 - 7].first_line, _$[$0 - 7].first_column);
                        this.$ = null;
                    }
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'ELEMENTO', null, [new Nodo(cst.cstXmlAsc.getId(), 'lt', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 7].toString().replaceAll("\"", ""), null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'identificador', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 6].toString().replaceAll("\"", ""), null, [])]),
                        cst.cstXmlAsc.obtenerUltimoNodo(),
                        new Nodo(cst.cstXmlAsc.getId(), 'gt', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 4].toString().replaceAll("\"", ""), null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'lt', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 3].toString().replaceAll("\"", ""), null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'diag', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 2].toString().replaceAll("\"", ""), null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'identificador', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 1].toString().replaceAll("\"", ""), null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'gt', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 10:
                    console.log('Entra a error sintactico');
                    errores.default.agregarError('sintactico', 'Token inesperado \'' + yytext + '\'', _$[$0 - 1].first_line, _$[$0 - 1].first_column);
                    this.$ = null;
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'ELEMENTO', null, []));
                    break;
                case 11:
                    this.$ = $$[$0];
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'LISTAATRIBUTOS', null, [cst.cstXmlAsc.obtenerUltimoNodo()]));
                    break;
                case 12:
                    this.$ = [];
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'LISTAATRIBUTOS', null, [new Nodo(cst.cstXmlAsc.getId(), 'epsilon', null, [])]));
                    break;
                case 13:
                    $$[$0 - 1].push($$[$0]);
                    this.$ = $$[$0 - 1];
                    /* CONSTRUCCION DE CST */
                    let atr2 = cst.cstXmlAsc.obtenerUltimoNodo();
                    let atrs2 = cst.cstXmlAsc.obtenerUltimoNodo();
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'ATRIBUTOS', null, [atrs2, atr2]));
                    break;
                case 14:
                    this.$ = [$$[$0]];
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'ATRIBUTOS', null, [cst.cstXmlAsc.obtenerUltimoNodo()]));
                    break;
                case 15:
                case 16:
                    this.$ = new Atributo($$[$0 - 2].toString().replaceAll("\"", ""), $$[$0], _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'ATRIBUTO', null, [new Nodo(cst.cstXmlAsc.getId(), 'identificador', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 2].toString().replaceAll("\"", ""), null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'asignacion', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0 - 1].toString().replaceAll("\"", ""), null, [])]),
                        new Nodo(cst.cstXmlAsc.getId(), 'cadena', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 17:
                    console.log('Entra a error Atribut sintactico');
                    errores.default.agregarError('sintactico', 'Token inesperado \'' + yytext + '\'', _$[$0].first_line, _$[$0].first_column);
                    this.$ = new Atributo("", "", _$[$0].first_line, _$[$0].first_column);
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'ATRIBUTO', null, []));
                    break;
                case 18:
                    $$[$0 - 1] = $$[$0 - 1] + " " + $$[$0];
                    this.$ = $$[$0 - 1];
                    /* CONSTRUCCION DE CST */
                    let text2 = cst.cstXmlAsc.obtenerUltimoNodo();
                    let textContent2 = cst.cstXmlAsc.obtenerUltimoNodo();
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'TEXTCONTENT', null, [textContent2, text2]));
                    break;
                case 19:
                    this.$ = $$[$0];
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'TEXTCONTENT', null, [cst.cstXmlAsc.obtenerUltimoNodo()]));
                    break;
                case 20:
                    this.$ = $$[$0].toString().replaceAll("\"", "");
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlAsc.getId(), 'identificador', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 21:
                    this.$ = $$[$0].toString().replaceAll("\"", "");
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlAsc.getId(), 'content', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 22:
                    this.$ = $$[$0].toString().replaceAll("\"", "");
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlAsc.getId(), 'double', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 23:
                    this.$ = $$[$0].toString().replaceAll("\"", "");
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlAsc.getId(), 'integer', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 24:
                    this.$ = $$[$0].toString();
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlAsc.getId(), 'identificador', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 25:
                    this.$ = $$[$0].toString().replaceAll("\"", "");
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlAsc.getId(), 'comilla simple', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 26:
                    this.$ = "<";
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlAsc.getId(), 'menor que', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 27:
                    this.$ = ">";
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlAsc.getId(), 'mayor que', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 28:
                    this.$ = "&";
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlAsc.getId(), 'ampersand', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 29:
                    this.$ = "'";
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlAsc.getId(), 'apostrofe', null, [new Nodo(cst.cstXmlAsc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 30:
                    this.$ = "''";
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlAsc.getId(), 'comilla doble', null, [new Nodo(cst.cstXmlAsc.getId(), '"', null, [])])]));
                    break;
                case 31:
                    this.$ = $$[$0].toString().replaceAll("\"", "");
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlAsc.agregarPila(new Nodo(cst.cstXmlAsc.getId(), 'TEXT', null, []));
                    break;
            }
        },
        table: [{ 2: [1, 4], 3: 1, 4: 2, 6: [1, 3] }, { 1: [3] }, { 5: [1, 5] }, { 7: [1, 6] }, { 2: $V0, 6: $V1, 11: 7, 12: 8 }, { 1: [2, 1] }, { 8: [1, 11] }, { 2: $V0, 5: [2, 3], 6: $V1, 12: 12 }, o($V2, [2, 5]), { 13: $V3 }, { 10: $V4 }, { 2: $V5, 7: $V6, 9: 15, 13: $V7, 16: 16, 17: 17 }, o($V2, [2, 4]), o([10, 14], $V6, { 16: 16, 17: 17, 9: 20, 2: $V5, 13: $V7 }), o($V2, [2, 10]), { 7: [1, 21] }, o([7, 10, 14], [2, 11], { 17: 22, 2: $V5, 13: $V7 }), o($V8, [2, 14]), { 18: [1, 23] }, o($V8, [2, 17]), { 10: [1, 25], 14: [1, 24] }, { 10: [1, 26] }, o($V8, [2, 13]), { 19: [1, 27], 20: [1, 28] }, { 10: [1, 29] }, { 2: [1, 45], 6: [1, 32], 8: $V9, 11: 31, 12: 8, 13: $Va, 15: 30, 21: 33, 22: $Vb, 23: $Vc, 24: $Vd, 25: $Ve, 26: $Vf, 27: $Vg, 28: $Vh, 29: $Vi, 30: $Vj }, { 2: $V0, 6: $V1, 11: 46, 12: 8 }, o($V8, [2, 15]), o($V8, [2, 16]), o($V2, [2, 6]), { 2: [1, 49], 6: [1, 47], 8: $V9, 13: $Va, 21: 48, 22: $Vb, 23: $Vc, 24: $Vd, 25: $Ve, 26: $Vf, 27: $Vg, 28: $Vh, 29: $Vi, 30: $Vj }, { 2: $V0, 6: [1, 50], 12: 12 }, { 13: $V3, 14: [1, 51] }, o($Vk, [2, 19]), o($Vk, [2, 20]), o($Vk, [2, 21]), o($Vk, [2, 22]), o($Vk, [2, 23]), o($Vk, [2, 24]), o($Vk, [2, 25]), o($Vk, [2, 26]), o($Vk, [2, 27]), o($Vk, [2, 28]), o($Vk, [2, 29]), o($Vk, [2, 30]), o($Vk, $Vl, { 10: $V4 }), { 2: $V0, 5: [2, 2], 6: $V1, 12: 12 }, { 14: [1, 52] }, o($Vk, [2, 18]), o($Vk, $Vl), { 13: $V3, 14: [1, 53] }, { 13: [1, 54] }, { 13: [1, 55] }, { 13: [1, 56] }, { 10: [1, 57] }, { 10: [1, 58] }, { 10: [1, 59] }, o($V2, [2, 9]), o($V2, [2, 7]), o($V2, [2, 8])],
        defaultActions: { 5: [2, 1] },
        parseError: function parseError(str, hash) {
            if (hash.recoverable) {
                this.trace(str);
            }
            else {
                var error = new Error(str);
                error.hash = hash;
                throw error;
            }
        },
        parse: function parse(input) {
            var self = this, stack = [0], tstack = [], // token stack
            vstack = [null], // semantic value stack
            lstack = [], // location stack
            table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
            var args = lstack.slice.call(arguments, 1);
            //this.reductionCount = this.shiftCount = 0;
            var lexer = Object.create(this.lexer);
            var sharedState = { yy: {} };
            // copy state
            for (var k in this.yy) {
                if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
                    sharedState.yy[k] = this.yy[k];
                }
            }
            lexer.setInput(input, sharedState.yy);
            sharedState.yy.lexer = lexer;
            sharedState.yy.parser = this;
            if (typeof lexer.yylloc == 'undefined') {
                lexer.yylloc = {};
            }
            var yyloc = lexer.yylloc;
            lstack.push(yyloc);
            var ranges = lexer.options && lexer.options.ranges;
            if (typeof sharedState.yy.parseError === 'function') {
                this.parseError = sharedState.yy.parseError;
            }
            else {
                this.parseError = Object.getPrototypeOf(this).parseError;
            }
            function popStack(n) {
                stack.length = stack.length - 2 * n;
                vstack.length = vstack.length - n;
                lstack.length = lstack.length - n;
            }
            _token_stack: var lex = function () {
                var token;
                token = lexer.lex() || EOF;
                // if token isn't its numeric value, convert
                if (typeof token !== 'number') {
                    token = self.symbols_[token] || token;
                }
                return token;
            };
            var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
            while (true) {
                // retreive state number from top of stack
                state = stack[stack.length - 1];
                // use default actions if available
                if (this.defaultActions[state]) {
                    action = this.defaultActions[state];
                }
                else {
                    if (symbol === null || typeof symbol == 'undefined') {
                        symbol = lex();
                    }
                    // read action for current state and first input
                    action = table[state] && table[state][symbol];
                }
                _handle_error: 
                // handle parse error
                if (typeof action === 'undefined' || !action.length || !action[0]) {
                    var error_rule_depth;
                    var errStr = '';
                    // Return the rule stack depth where the nearest error rule can be found.
                    // Return FALSE when no error recovery rule was found.
                    function locateNearestErrorRecoveryRule(state) {
                        var stack_probe = stack.length - 1;
                        var depth = 0;
                        // try to recover from error
                        for (;;) {
                            // check for error recovery rule in this state
                            if ((TERROR.toString()) in table[state]) {
                                return depth;
                            }
                            if (state === 0 || stack_probe < 2) {
                                return false; // No suitable error recovery rule available.
                            }
                            stack_probe -= 2; // popStack(1): [symbol, action]
                            state = stack[stack_probe];
                            ++depth;
                        }
                    }
                    if (!recovering) {
                        // first see if there's any chance at hitting an error recovery rule:
                        error_rule_depth = locateNearestErrorRecoveryRule(state);
                        // Report error
                        expected = [];
                        for (p in table[state]) {
                            if (this.terminals_[p] && p > TERROR) {
                                expected.push("'" + this.terminals_[p] + "'");
                            }
                        }
                        if (lexer.showPosition) {
                            errStr = 'Parse error on line ' + (yylineno + 1) + ":\n" + lexer.showPosition() + "\nExpecting " + expected.join(', ') + ", got '" + (this.terminals_[symbol] || symbol) + "'";
                        }
                        else {
                            errStr = 'Parse error on line ' + (yylineno + 1) + ": Unexpected " +
                                (symbol == EOF ? "end of input" :
                                    ("'" + (this.terminals_[symbol] || symbol) + "'"));
                        }
                        this.parseError(errStr, {
                            text: lexer.match,
                            token: this.terminals_[symbol] || symbol,
                            line: lexer.yylineno,
                            loc: yyloc,
                            expected: expected,
                            recoverable: (error_rule_depth !== false)
                        });
                    }
                    else if (preErrorSymbol !== EOF) {
                        error_rule_depth = locateNearestErrorRecoveryRule(state);
                    }
                    // just recovered from another error
                    if (recovering == 3) {
                        if (symbol === EOF || preErrorSymbol === EOF) {
                            throw new Error(errStr || 'Parsing halted while starting to recover from another error.');
                        }
                        // discard current lookahead and grab another
                        yyleng = lexer.yyleng;
                        yytext = lexer.yytext;
                        yylineno = lexer.yylineno;
                        yyloc = lexer.yylloc;
                        symbol = lex();
                    }
                    // try to recover from error
                    if (error_rule_depth === false) {
                        throw new Error(errStr || 'Parsing halted. No suitable error recovery rule available.');
                    }
                    popStack(error_rule_depth);
                    preErrorSymbol = (symbol == TERROR ? null : symbol); // save the lookahead token
                    symbol = TERROR; // insert generic error symbol as new lookahead
                    state = stack[stack.length - 1];
                    action = table[state] && table[state][TERROR];
                    recovering = 3; // allow 3 real symbols to be shifted before reporting a new error
                }
                // this shouldn't happen, unless resolve defaults are off
                if (action[0] instanceof Array && action.length > 1) {
                    throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
                }
                switch (action[0]) {
                    case 1: // shift
                        //this.shiftCount++;
                        stack.push(symbol);
                        vstack.push(lexer.yytext);
                        lstack.push(lexer.yylloc);
                        stack.push(action[1]); // push state
                        symbol = null;
                        if (!preErrorSymbol) { // normal execution/no error
                            yyleng = lexer.yyleng;
                            yytext = lexer.yytext;
                            yylineno = lexer.yylineno;
                            yyloc = lexer.yylloc;
                            if (recovering > 0) {
                                recovering--;
                            }
                        }
                        else {
                            // error just occurred, resume old lookahead f/ before error
                            symbol = preErrorSymbol;
                            preErrorSymbol = null;
                        }
                        break;
                    case 2:
                        // reduce
                        //this.reductionCount++;
                        len = this.productions_[action[1]][1];
                        // perform semantic action
                        yyval.$ = vstack[vstack.length - len]; // default to $$ = $1
                        // default location, uses first token for firsts, last for lasts
                        yyval._$ = {
                            first_line: lstack[lstack.length - (len || 1)].first_line,
                            last_line: lstack[lstack.length - 1].last_line,
                            first_column: lstack[lstack.length - (len || 1)].first_column,
                            last_column: lstack[lstack.length - 1].last_column
                        };
                        if (ranges) {
                            yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
                        }
                        r = this.performAction.apply(yyval, [yytext, yyleng, yylineno, sharedState.yy, action[1], vstack, lstack].concat(args));
                        if (typeof r !== 'undefined') {
                            return r;
                        }
                        // pop off stack
                        if (len) {
                            stack = stack.slice(0, -1 * len * 2);
                            vstack = vstack.slice(0, -1 * len);
                            lstack = lstack.slice(0, -1 * len);
                        }
                        stack.push(this.productions_[action[1]][0]); // push nonterminal (reduce)
                        vstack.push(yyval.$);
                        lstack.push(yyval._$);
                        // goto new state = table[STATE][NONTERMINAL]
                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
                        stack.push(newState);
                        break;
                    case 3:
                        // accept
                        return true;
                }
            }
            return true;
        } };
    //const Nodo = require("./AST/nodo_arbol");
    //var raiz;
    const { Objeto } = require("../XML/Objeto");
    const { Atributo } = require("../XML/Atributo");
    const errores = require('../Global/ListaError');
    const { Nodo } = require('../Reporte/Nodo');
    const cst = require('../Reporte/CST');
    /* generated by jison-lex 0.3.4 */
    var lexer = (function () {
        var lexer = ({
            EOF: 1,
            parseError: function parseError(str, hash) {
                if (this.yy.parser) {
                    this.yy.parser.parseError(str, hash);
                }
                else {
                    throw new Error(str);
                }
            },
            // resets the lexer, sets new input
            setInput: function (input, yy) {
                this.yy = yy || this.yy || {};
                this._input = input;
                this._more = this._backtrack = this.done = false;
                this.yylineno = this.yyleng = 0;
                this.yytext = this.matched = this.match = '';
                this.conditionStack = ['INITIAL'];
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0
                };
                if (this.options.ranges) {
                    this.yylloc.range = [0, 0];
                }
                this.offset = 0;
                return this;
            },
            // consumes and returns one char from the input
            input: function () {
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                var lines = ch.match(/(?:\r\n?|\n).*/g);
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                }
                else {
                    this.yylloc.last_column++;
                }
                if (this.options.ranges) {
                    this.yylloc.range[1]++;
                }
                this._input = this._input.slice(1);
                return ch;
            },
            // unshifts one char (or a string) into the input
            unput: function (ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len);
                //this.yyleng -= len;
                this.offset -= len;
                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
                this.match = this.match.substr(0, this.match.length - 1);
                this.matched = this.matched.substr(0, this.matched.length - 1);
                if (lines.length - 1) {
                    this.yylineno -= lines.length - 1;
                }
                var r = this.yylloc.range;
                this.yylloc = {
                    first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: lines ?
                        (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                            + oldLines[oldLines.length - lines.length].length - lines[0].length :
                        this.yylloc.first_column - len
                };
                if (this.options.ranges) {
                    this.yylloc.range = [r[0], r[0] + this.yyleng - len];
                }
                this.yyleng = this.yytext.length;
                return this;
            },
            // When called from action, caches matched text and appends it on next action
            more: function () {
                this._more = true;
                return this;
            },
            // When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
            reject: function () {
                if (this.options.backtrack_lexer) {
                    this._backtrack = true;
                }
                else {
                    return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                        text: "",
                        token: null,
                        line: this.yylineno
                    });
                }
                return this;
            },
            // retain first n characters of the match
            less: function (n) {
                this.unput(this.match.slice(n));
            },
            // displays already matched input, i.e. for error messages
            pastInput: function () {
                var past = this.matched.substr(0, this.matched.length - this.match.length);
                return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, "");
            },
            // displays upcoming input, i.e. for error messages
            upcomingInput: function () {
                var next = this.match;
                if (next.length < 20) {
                    next += this._input.substr(0, 20 - next.length);
                }
                return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
            },
            // displays the character position where the lexing error occurred, i.e. for error messages
            showPosition: function () {
                var pre = this.pastInput();
                var c = new Array(pre.length + 1).join("-");
                return pre + this.upcomingInput() + "\n" + c + "^";
            },
            // test the lexed token: return FALSE when not a match, otherwise return token
            test_match: function (match, indexed_rule) {
                var token, lines, backup;
                if (this.options.backtrack_lexer) {
                    // save context
                    backup = {
                        yylineno: this.yylineno,
                        yylloc: {
                            first_line: this.yylloc.first_line,
                            last_line: this.last_line,
                            first_column: this.yylloc.first_column,
                            last_column: this.yylloc.last_column
                        },
                        yytext: this.yytext,
                        match: this.match,
                        matches: this.matches,
                        matched: this.matched,
                        yyleng: this.yyleng,
                        offset: this.offset,
                        _more: this._more,
                        _input: this._input,
                        yy: this.yy,
                        conditionStack: this.conditionStack.slice(0),
                        done: this.done
                    };
                    if (this.options.ranges) {
                        backup.yylloc.range = this.yylloc.range.slice(0);
                    }
                }
                lines = match[0].match(/(?:\r\n?|\n).*/g);
                if (lines) {
                    this.yylineno += lines.length;
                }
                this.yylloc = {
                    first_line: this.yylloc.last_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.last_column,
                    last_column: lines ?
                        lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                        this.yylloc.last_column + match[0].length
                };
                this.yytext += match[0];
                this.match += match[0];
                this.matches = match;
                this.yyleng = this.yytext.length;
                if (this.options.ranges) {
                    this.yylloc.range = [this.offset, this.offset += this.yyleng];
                }
                this._more = false;
                this._backtrack = false;
                this._input = this._input.slice(match[0].length);
                this.matched += match[0];
                token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                if (this.done && this._input) {
                    this.done = false;
                }
                if (token) {
                    return token;
                }
                else if (this._backtrack) {
                    // recover context
                    for (var k in backup) {
                        this[k] = backup[k];
                    }
                    return false; // rule action called reject() implying the next rule should be tested instead.
                }
                return false;
            },
            // return next match in input
            next: function () {
                if (this.done) {
                    return this.EOF;
                }
                if (!this._input) {
                    this.done = true;
                }
                var token, match, tempMatch, index;
                if (!this._more) {
                    this.yytext = '';
                    this.match = '';
                }
                var rules = this._currentRules();
                for (var i = 0; i < rules.length; i++) {
                    tempMatch = this._input.match(this.rules[rules[i]]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (this.options.backtrack_lexer) {
                            token = this.test_match(tempMatch, rules[i]);
                            if (token !== false) {
                                return token;
                            }
                            else if (this._backtrack) {
                                match = false;
                                continue; // rule action called reject() implying a rule MISmatch.
                            }
                            else {
                                // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                                return false;
                            }
                        }
                        else if (!this.options.flex) {
                            break;
                        }
                    }
                }
                if (match) {
                    token = this.test_match(match, rules[index]);
                    if (token !== false) {
                        return token;
                    }
                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                    return false;
                }
                if (this._input === "") {
                    return this.EOF;
                }
                else {
                    return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                        text: "",
                        token: null,
                        line: this.yylineno
                    });
                }
            },
            // return next match that has a token
            lex: function lex() {
                var r = this.next();
                if (r) {
                    return r;
                }
                else {
                    return this.lex();
                }
            },
            // activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
            begin: function begin(condition) {
                this.conditionStack.push(condition);
            },
            // pop the previously active lexer condition state off the condition stack
            popState: function popState() {
                var n = this.conditionStack.length - 1;
                if (n > 0) {
                    return this.conditionStack.pop();
                }
                else {
                    return this.conditionStack[0];
                }
            },
            // produce the lexer rule set which is active for the currently active lexer condition state
            _currentRules: function _currentRules() {
                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
                    return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
                }
                else {
                    return this.conditions["INITIAL"].rules;
                }
            },
            // return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
            topState: function topState(n) {
                n = this.conditionStack.length - 1 - Math.abs(n || 0);
                if (n >= 0) {
                    return this.conditionStack[n];
                }
                else {
                    return "INITIAL";
                }
            },
            // alias for begin(condition)
            pushState: function pushState(condition) {
                this.begin(condition);
            },
            // return the number of states currently on the stack
            stateStackSize: function stateStackSize() {
                return this.conditionStack.length;
            },
            options: {},
            performAction: function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
                var YYSTATE = YY_START;
                switch ($avoiding_name_collisions) {
                    case 0: /* skip whitespace */
                        break;
                    case 1:
                        this.begin('comment');
                        break;
                    case 2:
                        this.popState();
                        break;
                    case 3: /* skip comment content*/
                        break;
                    case 4:
                        return 6;
                        break;
                    case 5:
                        return 10;
                        break;
                    case 6:
                        return 18;
                        break;
                    case 7:
                        return 14;
                        break;
                    case 8:
                        return 7;
                        break;
                    case 9:
                        return 25;
                        break;
                    case 10:
                        return "xml";
                        break;
                    case 11:
                        return 26;
                        break;
                    case 12:
                        return 27;
                        break;
                    case 13:
                        return 28;
                        break;
                    case 14:
                        return "apostrophe";
                        break;
                    case 15:
                        return "quot";
                        break;
                    case 16:
                        return 23;
                        break;
                    case 17:
                        return 24;
                        break;
                    case 18:
                        return 13;
                        break;
                    case 19:
                        return 19;
                        break;
                    case 20:
                        return 20;
                        break;
                    case 21:
                        return 22;
                        break;
                    case 22:
                        return 5;
                        break;
                    case 23:
                        console.log(errores.default);
                        errores.default.agregarError('lexico', 'Simbolo inesperado ' + yy_.yytext, yy_.yylloc.first_line, yy_.yylloc.first_column);
                        break;
                }
            },
            rules: [/^(?:\s+)/, /^(?:<!--)/, /^(?:-->)/, /^(?:.)/, /^(?:<)/, /^(?:>)/, /^(?:=)/, /^(?:\/)/, /^(?:\?)/, /^(?:')/, /^(?:[xX][mM][lL])/, /^(?:&lt;)/, /^(?:&gt;)/, /^(?:&amp;)/, /^(?:&apos;)/, /^(?:&quot;)/, /^(?:(([0-9]+\.[0-9]*)|(\.[0-9]+)))/, /^(?:[0-9]+)/, /^(?:[a-zA-Z_][a-zA-Z0-9_ñÑ.-]*)/, /^(?:("((\\([\'\"\\]))|([^\"\\]+))*"))/, /^(?:('((\\([\'\"\\]))|([^\'\\]))*'))/, /^(?:([^<]))/, /^(?:$)/, /^(?:.)/],
            conditions: { "comment": { "rules": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23], "inclusive": true }, "INITIAL": { "rules": [0, 1, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23], "inclusive": true } }
        });
        return lexer;
    })();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser;
})();
if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
    exports.parser = XML_GramaticaAsc;
    exports.Parser = XML_GramaticaAsc.Parser;
    exports.parse = function () { return XML_GramaticaAsc.parse.apply(XML_GramaticaAsc, arguments); };
    exports.main = function commonjsMain(args) {
        if (!args[1]) {
            console.log('Usage: ' + args[0] + ' FILE');
            process.exit(1);
        }
        var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
        return exports.parser.parse(source);
    };
    if (typeof module !== 'undefined' && require.main === module) {
        exports.main(process.argv.slice(1));
    }
}
